// extracted by mini-css-extract-plugin
export default {"message":"SHRMMessage_message__vt7KH","fadeIn":"SHRMMessage_fadeIn__Jpi+S","fadeOut":"SHRMMessage_fadeOut__b7zoR"};